import { render, staticRenderFns } from "./UpdateForecastForm.vue?vue&type=template&id=47995450&"
import script from "./UpdateForecastForm.vue?vue&type=script&lang=js&"
export * from "./UpdateForecastForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports